import { useEffect, useState } from 'react';
import { Ingredient } from '../../../types/content.type';
import { Recipe } from '../../../types/lessonPlan.type';
import { scaleScalableHtml } from '../../../utils/recipeScaleUtils';
import SafeHTMLDisplay from '../../common/SafeHTMLDisplay';
import './RecipeIngredients.css';

interface RecipeIngredientsProps {
  recipes: Recipe[];
  scale: number;
  onScaleChange: (scale: number) => void;
}

const RecipeIngredients = ({ recipes, scale, onScaleChange }: RecipeIngredientsProps) => {
  const [ingredients, setIngredients] = useState<Ingredient[]>([]);
  const [scaledIngredients, setScaledIngredients] = useState<Ingredient[]>([]);

  const applyScale = (baseIngredients: Ingredient[], newScale: number) => {
    return baseIngredients.map((ingredient) => ({
      ...ingredient,
      name: scaleScalableHtml(ingredient.name, newScale)
    }));
  };

  const handleScaleChange = (newScale: number) => {
    onScaleChange(newScale);
    setScaledIngredients(applyScale(ingredients, newScale));
  };

  useEffect(() => {
    const recipeIngredients: Ingredient[] = [];
    recipes.forEach((recipe) => {
      if (recipe.ingredients.length) {
        recipeIngredients.push(...recipe.ingredients);
      }
    });
    if (recipeIngredients.length) {
      setIngredients(recipeIngredients);
      setScaledIngredients(applyScale(recipeIngredients, scale));
    }
  }, [recipes]);

  return (
      <>
        <div
            className="ingredients"
            id="ingredients"
        >
          <div className="scale mb-4">
            <div className="scale-copy">
              <div className="subheader tiny mb-0">scale</div>
            </div>
            {Array.from({ length: 7 }).map((_, index) => (
                <div
                    onClick={() => handleScaleChange(index + 1)}
                    className={`scale-amount scale-${index + 1}X ${scale === index + 1 ? 'active' : ''}`}
                    key={`scale-${index}`}
                >
                  <div>{index + 1}X</div>
                </div>
            ))}
          </div>
          <h3 className="text-info fw-bolder mb-4">Ingredients</h3>
          {recipes.map((recipe, index) => (
              <div key={`recipe-ingredient-${index}`}>
                {recipes.length > 1 && <h4 className="text-info fw-bold mb-2">{recipe.title}</h4>}
                <ul
                    role="list"
                    className="w-list-unstyled"
                >
                  {scaledIngredients
                      .filter((ingredient) => ingredient.recipe_id === recipe.id)
                      .map((ingredient, index) => (
                          <li key={`ingredient-${index}`}>
                            <SafeHTMLDisplay htmlContent={ingredient.name} />
                          </li>
                      ))}
                </ul>
              </div>
          ))}
        </div>
        <div className="dots recipe"></div>
      </>
  );
};

export default RecipeIngredients;